/**
 * Bottom sheet de leitura — comunicado institucional (professor, responsável, etc.).
 */
import { X } from 'lucide-react';
import { ComunicadoLeituraDetail } from './ComunicadoLeituraDetail';

export interface ComunicadoLeitura {
  id: string;
  titulo: string;
  corpo: string;
  tipo: string;
  destinatario: string;
  fixado?: boolean;
  criadoEm: string;
  dataEvento?: string | null;
  categoria?: string;
  turma?: { id: string; nome: string } | null;
  escola?: { id: string; nome: string } | null;
  municipio?: { id: string; nome: string } | null;
  criadoPor?: { nome?: string; perfil?: string } | null;
}

interface Props {
  comunicado: ComunicadoLeitura | null;
  onClose: () => void;
}

export function ComunicadoLeituraSheet({ comunicado: c, onClose }: Props) {
  if (!c) return null;

  return (
    <div
      className="comunicado-sheet-overlay"
      onClick={onClose}
      role="presentation"
    >
      <div
        className="comunicado-sheet-panel"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-labelledby="comunicado-sheet-title"
      >
        <div className="comunicado-sheet-handle" aria-hidden />
        <div className="comunicado-sheet-header comunicado-sheet-header--compact">
          <button type="button" className="comunicado-sheet-close" onClick={onClose} aria-label="Fechar">
            <X size={18} />
          </button>
        </div>
        <div className="comunicado-sheet-body">
          <ComunicadoLeituraDetail comunicado={c} titleId="comunicado-sheet-title" />
        </div>
        <button type="button" className="comunicado-sheet-btn-fechar" onClick={onClose}>
          Fechar
        </button>
      </div>
    </div>
  );
}
